module.exports = __webpack_public_path__ + "static/media/expandArrowIcon.a63aa712.svg";